import { Link } from "react-router-dom";
import { Eye, Heart, Star, Lock } from "lucide-react";
import { fileUrl, money } from "../lib/api";

export const Cover = ({ src, className = "" }) => src
  ? <img src={fileUrl(src)} alt="" loading="lazy" className={`object-cover ${className}`} />
  : <div className={`jx-halftone grid place-items-center jx-muted text-xs ${className}`}>No cover</div>;

export function ComicCard({ c, i = 0 }) {
  return (
    <Link to={`/comic/${c.id}`} data-testid={`comic-card-${c.id}`} className="group block jx-rise" style={{ animationDelay: `${i * 40}ms` }}>
      <div className="relative aspect-[2/3] rounded-xl overflow-hidden border border-[var(--jx-border)]">
        <Cover src={c.cover_url} className="w-full h-full transition-transform duration-500 group-hover:scale-105" />
        <div className="absolute top-2 left-2 flex flex-wrap gap-1">
          {c.is_boosted && <span className="jx-tag jx-promo px-2 py-0.5 rounded" data-testid="promoted-label">Promoted</span>}
          {c.ai_generated && <span className="jx-tag bg-[var(--jx-violet)] text-white px-2 py-0.5 rounded">AI-made</span>}
          {c.is_demo && <span className="jx-tag bg-black/70 text-white px-2 py-0.5 rounded">Demo</span>}
        </div>
        <div className="absolute bottom-2 right-2 jx-tag px-2 py-1 rounded bg-black/75 text-white flex items-center gap-1">
          {c.price_cents > 0 ? <><Lock size={10} />{money(c.price_cents)}</> : "Free"}
        </div>
      </div>
      <div className="mt-2">
        <div className="font-display font-semibold leading-tight line-clamp-1 group-hover:text-[var(--jx-pink)] transition-colors">{c.title}</div>
        <div className="text-xs jx-muted flex items-center gap-2 mt-0.5">
          <span className="truncate">@{c.creator?.username}</span>
          <span className="flex items-center gap-0.5"><Eye size={11} />{c.reads}</span>
          <span className="flex items-center gap-0.5"><Heart size={11} />{c.likes}</span>
          {c.rating_count > 0 && <span className="flex items-center gap-0.5"><Star size={11} />{c.rating_avg}</span>}
        </div>
      </div>
    </Link>
  );
}

export const Grid = ({ comics, testid }) => (
  <div data-testid={testid} className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
    {comics.map((c, i) => <ComicCard key={c.id} c={c} i={i} />)}
  </div>
);

export const Section = ({ title, kicker, children, action }) => (
  <section className="mt-12">
    <div className="flex items-end justify-between mb-5">
      <div>{kicker && <div className="jx-tag jx-mint mb-1">{kicker}</div>}<h2 className="text-2xl sm:text-3xl font-bold">{title}</h2></div>
      {action}
    </div>
    {children}
  </section>
);

export const MemberTag = ({ n }) => <span data-testid="member-number" className="jx-tag jx-mint">Member #{n}</span>;
export const Page = ({ children, className = "" }) => <main className={`max-w-7xl mx-auto px-4 pt-6 pb-28 md:pb-16 ${className}`}>{children}</main>;
